/**
 * 数値部分をカンマ区切り文字列にする
 *
 * 例: 1000 → 1,000
 * @param num 変換元
 */
export function numberWithCommas(num: number | string): string {
    return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}
